import { Link } from 'react-router-dom';
import { useState } from 'react';
import '../style/Footer.css';
import logo from '../images/kovan_logo.png';
import { LinkedInIcon } from './Icons';

const API = process.env.REACT_APP_API_URL || '';

const SERVICES = [
    { id: 1, serviceCode: 'SVC_CYBER',      name: 'Cyber Security' },
    { id: 2, serviceCode: 'SVC_CLOUD',      name: 'Cloud Services' },
    { id: 3, serviceCode: 'SVC_ENTERPRISE', name: 'Enterprise Applications' },
    { id: 4, serviceCode: 'SVC_SERVICENOW', name: 'ServiceNow' },
    { id: 5, serviceCode: 'SVC_AI',         name: 'AI & Data' },
];

const Footer = () => {
    const services = SERVICES;
    const [subEmail,  setSubEmail]  = useState('');
    const [subStatus, setSubStatus] = useState('idle'); // idle | sending | success | error

    const handleSubscribe = async (e) => {
        e.preventDefault();
        setSubStatus('sending');
        try {
            const res  = await fetch(`${API}/api/subscribe`, {
                method:  'POST',
                headers: { 'Content-Type': 'application/json' },
                body:    JSON.stringify({ email: subEmail })
            });
            if (!res.ok) {
                setSubStatus('error');
            } else {
                setSubStatus('success');
                setSubEmail('');
            }
        } catch {
            setSubStatus('error');
        }
    };

    return (
        <footer className="footer">
            <div className="footer-wrapper">
                <div className="footer-content">
                    {/* Column 1: Brand */}
                    <div className="footer-section brand-section">
                        <div className="footer-brand">
                            <img src={logo} alt="Kovan Logo" className="footer-logo-image" />
                        </div>
                        <p className="footer-desc">
                            Delivering AI-driven, cloud-native, and enterprise solutions that drive real business outcomes.
                        </p>
                        <div className="social-links">
                            <a href="https://www.linkedin.com/company/kovan-technology-solutions" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="LinkedIn">
                                <LinkedInIcon />
                            </a>
                        </div>
                    </div>

                    {/* Column 2: Services */}
                    <div className="footer-section">
                        <h3 className="footer-heading">Services</h3>
                        <ul className="footer-links">
                            {services.map((service) => (
                                <li key={service.id}>
                                    <Link to={`/services/${service.serviceCode}`} className="footer-link">
                                        {service.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Column 3: Company */}
                    <div className="footer-section">
                        <h3 className="footer-heading">Company</h3>
                        <ul className="footer-links">
                            <li><Link to="/about#our-journey" className="footer-link">About Kovan</Link></li>
                            <li><Link to="/contact" className="footer-link">Contact Us</Link></li>
                            <li><Link to="/contact#global-hubs" className="footer-link">Global Offices</Link></li>
                            <li><Link to="/careers" className="footer-link">Careers</Link></li>
                        </ul>
                    </div>

                    {/* Column 4: Advisory Brief */}
                    <div className="footer-section advisory-section">
                        <h3 className="footer-heading">Advisory Brief</h3>
                        <p className="footer-desc">
                            Subscribe for quarterly strategic reports on enterprise architecture.
                        </p>
                        {subStatus === 'success' ? (
                            <p className="newsletter-success">✓ Subscribed! Thank you.</p>
                        ) : (
                            <form className="newsletter-form" onSubmit={handleSubscribe}>
                                <input
                                    type="email"
                                    placeholder="Email address"
                                    className="newsletter-input"
                                    value={subEmail}
                                    onChange={e => setSubEmail(e.target.value)}
                                    required
                                />
                                <button type="submit" className="newsletter-btn" disabled={subStatus === 'sending'}>
                                    {subStatus === 'sending' ? (
                                        <span style={{ fontSize: '12px' }}>...</span>
                                    ) : (
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <line x1="22" y1="2" x2="11" y2="13"></line>
                                            <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                                        </svg>
                                    )}
                                </button>
                            </form>
                        )}
                        {subStatus === 'error' && (
                            <p className="newsletter-error">Failed to subscribe. Please try again.</p>
                        )}
                    </div>
                </div>
            </div>
            <div className="footer-copyright">
                <div className="footer-copyright-inner">
                    <p>© {new Date().getFullYear()} Kovan Technology Solutions. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
